import axios from 'axios'
import { API_BASE_URL } from '@/config/env'

// 动态配置API基础URL
const getBaseURL = () => {
  // 使用统一的环境配置
  return API_BASE_URL
}

// 创建 axios 实例
const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    // 处理JWT相关错误和Token过期
    if (error.response?.data?.message?.includes('JWT signature does not match') ||
        error.response?.data?.message?.includes('JWT validity cannot be asserted') ||
        error.response?.data?.message?.includes('JWT') ||
        error.response?.data?.message?.includes('Token已过期') ||
        error.response?.status === 401) {
      console.warn('认证失败，清除登录状态并跳转到登录页')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      // 使用Element Plus的消息提示
      if (window.ElMessage) {
        window.ElMessage.error('登录已过期，请重新登录')
      }
      window.location.href = '#/login'
      return Promise.reject(error)
    }
    
    return Promise.reject(error)
  }
)

// 获取用户配置列表��包括共享配置）
export const getUserConfigs = (game = null, userStatus = null, targetUserId = null) => {
  const params = {
    includeShared: true
  }
  if (game) {
    params.game = game
  }
  if (userStatus) {
    params.userStatus = userStatus
  }
  if (targetUserId) {
    params.targetUserId = targetUserId
  }
  return api.get('/configs/', { params })
}

// 创建配置
export const createConfig = (configData) => {
  return api.post('/configs/', configData)
}

// 获取单个配置
export const getConfig = (configId) => {
  return api.get(`/configs/${configId}`)
}

// 更新配置
export const updateConfig = (configId, configData) => {
  return api.put(`/configs/${configId}`, configData)
}

// 删除配置
export const deleteConfig = (configId) => {
  return api.delete(`/configs/${configId}`)
}

// 复制配置
export const copyConfig = (configId) => {
  return api.post(`/configs/${configId}/copy`)
}

// 为角色分配配置
export const assignConfigToRoles = (roleIds, configId) => {
  return api.post('/configs/assign', {
    role_ids: roleIds,
    config_id: configId
  })
}

// 批量更新角色配置
export const batchUpdateRoleConfigs = (data) => {
  return api.post('/configs/batch-update-roles', data)
}

// 设置配置共享状态
export const setConfigShared = (configId, isShared) => {
  return api.put(`/configs/${configId}/shared`, { isShared })
}